<div class="min-h-screen flex items-center justify-center bg-gray-900 py-12 px-4 sm:px-6 lg:px-8">
  <div class="max-w-md w-full space-y-8">
    <div>
      <img
        class="mx-auto h-16 w-auto"
        src="assets/images/logo.svg"
        alt="DWT Logo"
        width="200"
        height="64"
        style="max-width: 200px; height: auto;"
      />
      <h2 class="mt-6 text-center text-3xl font-extrabold text-white">
        {{ mode === 'login' ? 'Sign in to your account' : 'Wachtwoord vergeten?' }}
      </h2>
      <p class="mt-2 text-center text-sm text-gray-400">
        {{ mode === 'login'
            ? "Let's go to the DWT cockpit!"
            : 'Vul je e-mailadres in en we sturen je een link om een nieuw wachtwoord in te stellen.' }}
      </p>
    </div>

    <!-- Login mode -->
    <form *ngIf="mode === 'login'" class="mt-8 space-y-6" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <div class="rounded-md shadow-sm -space-y-px">
        <div>
          <label for="email-address" class="sr-only">Email address</label>
          <input
            formControlName="email"
            id="email-address"
            name="email"
            type="email"
            required
            class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-600 placeholder-gray-400 text-white bg-gray-800 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
            placeholder="Email address"
          />
        </div>
        <div>
          <label for="password" class="sr-only">Password</label>
          <input
            formControlName="password"
            id="password"
            name="password"
            type="password"
            required
            class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-600 placeholder-gray-400 text-white bg-gray-800 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
            placeholder="Password"
          />
        </div>
      </div>

      <div class="flex items-center justify-end">
        <button
          type="button"
          (click)="showForgotPassword()"
          class="text-sm text-indigo-400 hover:text-indigo-300 font-medium focus:outline-none focus:underline"
        >
          Wachtwoord vergeten?
        </button>
      </div>

      <div>
        <button
          type="submit"
          [disabled]="!loginForm.valid"
          class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-150"
        >
          <span class="absolute left-0 inset-y-0 flex items-center pl-3">
            <svg class="h-5 w-5 text-indigo-500 group-hover:text-indigo-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clip-rule="evenodd" />
            </svg>
          </span>
          Sign in
        </button>
      </div>

      <div *ngIf="errorMessage" class="text-red-400 text-center text-sm bg-red-900 bg-opacity-50 p-3 rounded-md">
        {{ errorMessage }}
      </div>
    </form>

    <!-- Reset mode -->
    <form *ngIf="mode === 'reset'" class="mt-8 space-y-6" [formGroup]="resetForm" (ngSubmit)="onResetSubmit()">
      <div>
        <label for="reset-email" class="sr-only">Email address</label>
        <input
          formControlName="email"
          id="reset-email"
          name="email"
          type="email"
          required
          autocomplete="email"
          class="appearance-none relative block w-full px-3 py-2 border border-gray-600 placeholder-gray-400 text-white bg-gray-800 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          placeholder="jouw@email.nl"
        />
      </div>

      <div>
        <button
          type="submit"
          [disabled]="!resetForm.valid || resetSubmitting"
          class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-150"
        >
          {{ resetSubmitting ? 'Bezig met versturen...' : 'Verstuur reset-link' }}
        </button>
      </div>

      <div class="text-center">
        <button
          type="button"
          (click)="showLogin()"
          class="text-sm text-gray-400 hover:text-gray-200 focus:outline-none focus:underline"
        >
          Terug naar inloggen
        </button>
      </div>

      <div *ngIf="resetInfoMessage" class="text-green-300 text-center text-sm bg-green-900 bg-opacity-40 p-3 rounded-md">
        {{ resetInfoMessage }}
      </div>
      <div *ngIf="resetErrorMessage" class="text-red-400 text-center text-sm bg-red-900 bg-opacity-50 p-3 rounded-md">
        {{ resetErrorMessage }}
      </div>
    </form>
  </div>
</div>
